export default __webpack_public_path__ + "static/media/tpc-logo.34cccea9.svg";